import { BoardLayout } from "~/config/andonBoardLayouts/andonLayout.types";

const layouts: BoardLayout[] = [
  {
    name: "UWA6",
    dimensions: {
      rows: 3,
      columns: 5
    },
    layout: [
      {
        i: "b27876c6-06ce-465f-b948-13e7d3e4fc8d",
        x: 0,
        y: 0,
        w: 1,
        h: 1,
        maxH: 3
      },
      {
        i: "3e66f2d7-7de6-4949-a581-e89cd3b767c7",
        x: 1,
        y: 0,
        w: 1,
        h: 1,
        maxH: 3
      },
      {
        i: "b15a5ba3-1365-48c6-a5a2-51ec324a138e",
        x: 2,
        y: 0,
        w: 1,
        h: 1,
        maxH: 3
      },
      {
        i: "4bbac574-27ab-4d92-9205-20fb3e10030f",
        x: 3,
        y: 0,
        w: 1,
        h: 1,
        maxH: 3
      },
      {
        i: "93801d2c-ac41-4c32-b818-9baa1829c577",
        x: 4,
        y: 0,
        w: 1,
        h: 1,
        maxH: 3
      },
      {
        i: "b6808a84-6602-431c-8430-23b68f713b67",
        x: 0,
        y: 1,
        w: 1,
        h: 1,
        maxH: 2
      },
      {
        i: "3d6c9091-393c-429e-bb63-c20d40dd67e4",
        x: 1,
        y: 1,
        w: 1,
        h: 1,
        maxH: 2
      },
      {
        i: "1d5d2125-43bc-476b-9c61-5eb3ba4434af",
        x: 2,
        y: 1,
        w: 1,
        h: 1,
        maxH: 2
      },
      {
        i: "e5103242-51a6-4c92-af73-e06bcf6b2df2",
        x: 3,
        y: 1,
        w: 1,
        h: 1,
        maxH: 2
      },
      {
        i: "657bf12b-0e73-45be-bc6e-2f578436d217",
        x: 4,
        y: 1,
        w: 1,
        h: 1,
        maxH: 2
      },
      {
        i: "f16f6a95-5829-4e56-9cb5-c8cfd766aa56",
        x: 0,
        y: 2,
        w: 1,
        h: 1,
        maxH: 1
      },
      {
        i: "bb6599b9-2639-430a-b82e-dd4de6a779c4",
        x: 1,
        y: 2,
        w: 1,
        h: 1,
        maxH: 1
      },
      {
        i: "5f6cd885-3768-4e80-82e6-a9890120de6f",
        x: 2,
        y: 2,
        w: 1,
        h: 1,
        maxH: 1
      },
      {
        i: "66df307c-4da8-4f7a-899d-cfc7fb97f6a3",
        x: 3,
        y: 2,
        w: 1,
        h: 1,
        maxH: 1
      },
      {
        i: "eda9de80-64e6-4c99-a624-f192bee1b37f",
        x: 4,
        y: 2,
        w: 1,
        h: 1,
        maxH: 1
      }
    ]
  }
];

export default layouts;
